<template lang="pug">
  .scale-image(
    :class="modelValue && 'zoomed-in'"
    @click="emit('update:modelValue', !modelValue)"
  )
    DynamicMedia.scalable-image(
      :config="{src: source, alt: 'Product Image', autoHeight: true}"
      :contain="true"
    )
    .zoom-scale
      Icon(:name="modelValue ? 'x' : 'expand'" fill="black")
</template>
<script setup lang="ts">
import { watch, type PropType } from 'vue'
import { useMQ } from '../../js/mq'

defineProps({
  source: {
    type     : String,
    required : true,
  },
  modelValue: {
    type     : Boolean,
    required : true,
  },
})

const emit = defineEmits(['update:modelValue'])

const mq = useMQ()

watch(mq, (val) => {
  if (['mobile', 'tablet'].indexOf(val) !== -1) {
    emit('update:modelValue', false)
  }
})
</script>
<style lang="scss" scoped>

@mixin scalable-transition() {
  transition: all 0.2s ease-out;
}

// Mobile styles
.scale-image {
  display: none;
}

@include all-desktop() {
  .scale-image {
    position: relative;
    margin-bottom: $space-s;
    object-fit: contain;
    display: block;
    cursor: pointer;

    :deep(.rg-img) {
      background-color: transparent;
    }

    @include scalable-transition();

    .zoom-scale {
      position: absolute;
      bottom: $space-m;
      right: $space-m;

      .icon {
        width: $size-xxxxl;
        height: $size-xxxxl;
      }
    }
  }

  .scale-image.zoomed-in {
    position: relative;

    .scalable-image {
      height: 100%;
      width: 100%;

      :deep(img) {
        max-height: calc(100vh + 100px);
      }
    }

    .zoom-scale {
      bottom: auto;
      top: $space-m;
      border: 1px solid rgb(248, 248, 248);
      background-color: rgba(255, 255, 255, 0.8);
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
      padding: $space-xxs;

      .icon {
        width: $size-m;
        height: $size-m;
      }
    }

  }

  .scalable-image {
    background-color: transparent;

    :deep(img) {
      @include scalable-transition();
      max-height: 800px;
    }
  }

}
</style>
